export enum EbetStringFormattingMethod {
  None = "None",
  ToLower = "ToLower",
  ToProper = "ToProper",
  ToProperName = "ToProperName",
  ToUpper = "ToUpper",
}

export const EbetStringFormattingMethodList = () =>
  Object.entries(EbetStringFormattingMethod).map(([label, value]) => {
    return { label: value, value: label };
  });
